var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0863 1.36701L24.623 7.90371C25.779 9.05972 25.779 10.934 24.623 12.09L13.201 23.5102L21.2235 23.5105C21.7231 23.5105 22.1359 23.8817 22.2012 24.3633L22.2103 24.4972C22.2103 24.9967 21.839 25.4096 21.3574 25.4749L21.2235 25.4839L10.1591 25.4856C9.34843 25.5298 8.523 25.2423 7.90371 24.623L1.36701 18.0863C0.210997 16.9303 0.210997 15.056 1.36701 13.9L13.9 1.36701C15.056 0.210997 16.9303 0.210997 18.0863 1.36701ZM4.71789 13.3378L2.76244 15.2954C2.3771 15.6808 2.3771 16.3055 2.76244 16.6909L9.29914 23.2276C9.49181 23.4202 9.74433 23.5166 9.99685 23.5166L10.0348 23.5105L10.0855 23.5126C10.3077 23.4927 10.5245 23.3977 10.6946 23.2276L12.6498 21.271L4.71789 13.3378ZM15.2954 2.76244L6.11376 11.942L14.0457 19.8752L23.2276 10.6946C23.6129 10.3092 23.6129 9.68448 23.2276 9.29914L16.6909 2.76244C16.3055 2.3771 15.6808 2.3771 15.2954 2.76244Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.c6226c101058bc03caca1a4055049630.svg";
export { ForwardRef as ReactComponent };